export const getFeaturedMakes = (state) => {
  return state.makes.makeIds.slice(0, 2).map((id) => state.makes.makesById[id]);
};

export const getAllMakes = (state) => {
  return state.makes.makeIds.map((id) => state.makes.makesById[id]);
};

export const getMakeById = (state, id) => {
  return state.makes.makesById[id];
};
